import { render, staticRenderFns } from "./EventScanDetailTable.vue?vue&type=template&id=8e2853cc"
import script from "./EventScanDetailTable.vue?vue&type=script&lang=js"
export * from "./EventScanDetailTable.vue?vue&type=script&lang=js"
import style0 from "./EventScanDetailTable.vue?vue&type=style&index=0&id=8e2853cc&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports